import { IRequesterInfo } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IDeleteCurrentLogo } from '../models/models'

export class UpdateCurrentLogoApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/dealer/confirmLogo',
      requesterInfo,
    })
  }

  public async updateCurrent(request: IDeleteCurrentLogo): Promise<IDeleteCurrentLogo> {
    return await this.postAsync<IDeleteCurrentLogo>(request)
  }
}
